import { useCallback, useState } from "react"
import type { CombinedError } from "urql"

import type { Company } from "@/graphql/codegen/graphql"
import { useGetBaseCompanies } from "@/hooks/useGetBaseCompanies"

interface Props {
  withLocations?: boolean
}

interface ReturnProps {
  banks: Company[]
  isLoading: boolean
  error: CombinedError | undefined
  loadMore: () => void
  setSearchTerm: (term: string) => void
}

export const useBankCompanies = ({ withLocations }: Props = { withLocations: false }): ReturnProps => {
  const [searchTerm, setSearchTerm] = useState("")

  const { companies, isFetchingCompanies, companiesError, loadMoreCompanies } = useGetBaseCompanies(
    {
      types: ["BANK"],
      query: searchTerm || undefined,
    },
    withLocations
  )

  const handleSearchTermChange = useCallback((term: string) => {
    setSearchTerm(term)
  }, [])

  return {
    banks: companies,
    isLoading: isFetchingCompanies,
    error: companiesError,
    loadMore: loadMoreCompanies,
    setSearchTerm: handleSearchTermChange,
  }
}
